import { Component, DestroyRef, OnInit, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { BexioService } from '../services/bexio.service';
import { Router } from '@angular/router';
import { Auth2Service } from '../auth/auth2.service';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  imports: [FaIconComponent]
})
export class LoginComponent implements OnInit {
  readonly #auth2Service = inject(Auth2Service);
  readonly #bexioService = inject(BexioService);
  readonly #destroyRef = inject(DestroyRef);
  readonly #router = inject(Router);

  waitingForAuth = true;

  bexioSettings: any = {};

  ngOnInit() {
    // Get the grand url
    // this.bexioSettings = this.bexioService.statusSubject.getValue();
    this.#bexioService.status$
      .pipe(takeUntilDestroyed(this.#destroyRef))
      .subscribe(data => {
        this.bexioSettings = data;
        if (this.bexioSettings && this.bexioSettings.grantUrl) {
          if (!this.#auth2Service.isLoggedIn) {
            window.location.href = this.bexioSettings.grantUrl;
          }
        }
      });

    // Redirect when connected
    this.#auth2Service
      .connected()
      .pipe(takeUntilDestroyed(this.#destroyRef))
      .subscribe({
        next: (connected: boolean) => {
          if (connected) {
            void this.#router.navigate(['/logifleet']);
          }
        },
        error: () => (this.waitingForAuth = false)
      });

    this.#bexioService.init();
  }
}
